import React from 'react';

import { Link } from 'components/common/router';
import { Alert, Col, Row } from 'components/bootstrap';
import { IfPermitted } from 'components/common';
import Routes from 'routing/Routes';

const Status = () => (
  <Alert bsStyle="danger" title="Event Correlation is disabled">
    <p>
      Event Correlation is disabled due to the absence of a valid license. It is still possible to create or update any
      Event Correlation, but new Alerts and Events will not be generated from them.
    </p>
    <IfPermitted permissions="licenses:create">
      <p>
        See <Link to={Routes.pluginRoute('SYSTEM_LICENSES')}>Licenses page</Link> for details.
      </p>
    </IfPermitted>
  </Alert>
);

type Props = {
  licenseStatus: {
    status?: any;
    missing: boolean;
    loading: boolean;
  };
  summary?: boolean;
};

const EventsLicenseStatus = ({ licenseStatus: { status, missing }, summary = false }: Props) => {
  if (!missing && status && status.valid) {
    return null;
  }

  if (summary) {
    return <Status />;
  }

  return (
    <Row className="row-sm">
      <Col md={12}>
        <Status />
      </Col>
    </Row>
  );
};

export default EventsLicenseStatus;
